import { reactive } from 'vue'
import actions from '@/store/userExamMetadata/actions'
import state from '@/store/userExamMetadata/state'
import getters from '@/store/userExamMetadata/getters'

export const userExamMetadataModule = {
    state: reactive(state),
    actions,
    getters,
}
